'use strict';

var _countries = {
    us: 'United States of America',
    gb: 'United Kingdom',
    ca: 'Canada',
    br: 'Brazil',
    ae: 'United Arab Emirates',
    ag: 'Antigua and Barbuda',
    ai: 'Anguilla',
    al: 'Albania',
    am: 'Armenia',
    ao: 'Angola',
    ar: 'Argentina',
    at: 'Austria',
    au: 'Australia',
    az: 'Azerbaijan',
    bb: 'Barbados',
    be: 'Belgium',
    bf: 'Burkina-Faso',
    bg: 'Bulgaria',
    bh: 'Bahrain',
    bj: 'Benin',
    bm: 'Bermuda',
    bn: 'Brunei Darussalam',
    bo: 'Bolivia',
    bs: 'Bahamas',
    bt: 'Bhutan',
    bw: 'Botswana',
    by: 'Belarus',
    bz: 'Belize',
    cg: 'Democratic Republic of the Congo',
    ch: 'Switzerland',
    cl: 'Chile',
    cn: 'China',
    co: 'Colombia',
    cr: 'Costa Rica',
    cv: 'Cape Verde',
    cy: 'Cyprus',
    cz: 'Czech Republic',
    de: 'Germany',
    dk: 'Denmark',
    dm: 'Dominica',
    do: 'Dominican Republic',
    dz: 'Algeria',
    ec: 'Ecuador',
    ee: 'Estonia',
    eg: 'Egypt',
    es: 'Spain',
    fi: 'Finland',
    fj: 'Fiji',
    fm: 'Federated States of Micronesia',
    fr: 'France',
    gd: 'Grenada',
    gh: 'Ghana',
    gm: 'Gambia',
    gr: 'Greece',
    gt: 'Guatemala',
    gw: 'Guinea Bissau',
    gy: 'Guyana',
    hk: 'Hong Kong',
    hn: 'Honduras',
    hr: 'Croatia',
    hu: 'Hungaria',
    id: 'Indonesia',
    ie: 'Ireland',
    il: 'Israel',
    in: 'India',
    is: 'Iceland',
    it: 'Italy',
    jm: 'Jamaica',
    jo: 'Jordan',
    jp: 'Japan',
    ke: 'Kenya',
    kg: 'Krygyzstan',
    kh: 'Cambodia',
    kn: 'Saint Kitts and Nevis',
    kr: 'South Korea',
    kw: 'Kuwait',
    ky: 'Cayman Islands',
    kz: 'Kazakhstan',
    la: 'Laos',
    lb: 'Lebanon',
    lc: 'Saint Lucia',
    lk: 'Sri Lanka',
    lr: 'Liberia',
    lt: 'Lithuania',
    lu: 'Luxembourg',
    lv: 'Latvia',
    md: 'Moldova',
    mg: 'Madagascar',
    mk: 'Macedonia',
    ml: 'Mali',
    mn: 'Mongolia',
    mo: 'Macau',
    mr: 'Mauritania',
    ms: 'Montserrat',
    mt: 'Malta',
    mu: 'Mauritius',
    mw: 'Malawi',
    mx: 'Mexico',
    my: 'Malaysia',
    mz: 'Mozambique',
    na: 'Namibia',
    ne: 'Niger',
    ng: 'Nigeria',
    ni: 'Nicaragua',
    nl: 'Netherlands',
    np: 'Nepal',
    no: 'Norway',
    nz: 'New Zealand',
    om: 'Oman',
    pa: 'Panama',
    pe: 'Peru',
    pg: 'Papua New Guinea',
    ph: 'Philippines',
    pk: 'Pakistan',
    pl: 'Poland',
    pt: 'Portugal',
    pw: 'Palau',
    py: 'Paraguay',
    qa: 'Qatar',
    ro: 'Romania',
    ru: 'Russia',
    sa: 'Saudi Arabia',
    sb: 'Soloman Islands',
    sc: 'Seychelles',
    se: 'Sweden',
    sg: 'Singapore',
    si: 'Slovenia',
    sk: 'Slovakia',
    sl: 'Sierra Leone',
    sn: 'Senegal',
    sr: 'Suriname',
    st: 'Sao Tome e Principe',
    sv: 'El Salvador',
    sz: 'Swaziland',
    tc: 'Turks and Caicos Islands',
    td: 'Chad',
    th: 'Thailand',
    tj: 'Tajikistan',
    tm: 'Turkmenistan',
    tn: 'Tunisia',
    tr: 'Turkey',
    tt: 'Republic of Trinidad and Tobago',
    tw: 'Taiwan',
    tz: 'Tanzania',
    ua: 'Ukraine',
    ug: 'Uganda',
    uy: 'Uruguay',
    uz: 'Uzbekistan',
    vc: 'Saint Vincent and the Grenadines',
    ve: 'Venezuela',
    vg: 'British Virgin Islands',
    vn: 'Vietnam',
    ye: 'Yemen',
    za: 'South Africa',
    zw: 'Zimbabwe'
};

var CountryStore = {
    getCountries: function getCountries() {
        return _countries;
    }
};

module.exports = CountryStore;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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